<template lang="pug">
  .geo.apo-update.without-tabs( @click="showColorPallet=false")
    e-form-modal(
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.modal__title
          template(v-if="fields && fields.id") {{fields.name}}
          template(v-else) Добавление новой зоны деятельности
        .edit-select
          select.select(@change="changeEditSelect")
            option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          .body-flex(v-show="tabView === 'tab1'")
            .modal__row
              .modal__col
                e-form-group(
                  name="name"
                  inputType="input"
                  label="Наименование"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                e-form-group(
                  name="year_start"
                  inputType="select"
                  label="Год начала"
                  :model="fields"
                  tabView="tab1"
                  :options="operationYear"
                )
                e-form-group(
                  name="year_finish"
                  inputType="select"
                  label="Год окончания"
                  :model="fields"
                  tabView="tab1"
                  :options="operationYear"
                )
                e-form-group(
                  name="is_active"
                  inputType="select"
                  label="Активный"
                  :model="fields"
                  :required="true"
                  tabView="tab1",
                  :options="yesOrNo"
                )
                e-form-group(
                  name="status"
                  inputType="select"
                  label="Статус"
                  :model="fields"
                  :required="true"
                  tabView="tab1",
                  :options="status"
                )
                e-form-group(
                  v-if="hasReo"
                  name="reo_id"
                  inputType="input"
                  label="ППК РЭО ID"
                  :model="fields"
                  :required="false"
                  tabView="tab1"
                )
                e-form-group(
                  name="color"
                  label="Цвет"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                  slot
                    .color-chooser
                      div(
                        @click.stop.prevent="showColorPallet=!showColorPallet"
                        :style="{'background-color': fields.color}"
                      ).color-preview.color-chooser__preview
                      button(
                        @click.stop.prevent="showColorPallet=!showColorPallet"
                      ).actions-filter-panel__button.color-select-btn.color-chooser__btn.reset-btn.button.button_usual {{showColorPallet ? 'Скрыть палитру' : 'Выбор цвета'}}
                      div(
                        @click.stop.prevent=""
                      ).color-pallet.color-chooser__pallet
                        chrome(
                          v-if="showColorPallet"
                          v-model="fields.colorObject"
                          @input="updateColor"
                          :disableAlpha="true"
                        )
            div(style="margin-bottom:40px")
              e-form-group(
                name="tko_operator_id"
                label="Региональный оператор"
                :model="fields"
                tabView="tab1"
                :required="true"
              ).apo-form-group
                div(slot="label")
                slot
                  .table-choose-panel
                    .toolbar.toolbar_no-padding.toolbar_margin-bottom
                      div.line.toolbar__line
                        div.semibold Региональный оператор*
                        div.actions-panel
                          e-button-edit(@click="showTkoOperatorSelectTable=!showTkoOperatorSelectTable")
                  .table
                    table(style="width:100%")
                      thead
                        th.table__th.semibold Наименование
                        th.table__th
                      tbody
                        tr(v-if="fields.tkoOperator")
                          td.table__td(v-html="fields.tkoOperator.name || ' - '")
                          td.table__td(style='text-align: right')
                            e-button-delete.row-delete.reset-btn.button.button_delete.button_small.button_icon(@click="deleteTkoOperator")
                        tr(v-else)
                          td.table__td(colspan=100) Региональный оператор не указан
              e-modal(
                v-if="showTkoOperatorSelectTable"
                @close="showTkoOperatorSelectTable = false"
                @confirm="saveTkoOperator"
                title="Выбор оператора"
              )
                slot
                  e-table-checked-list(
                    selectType="radio"
                    ref="tkoOperatorSelectTable"
                    @checkedChange="tkoOperatorUpdate"
                    :endpoint="endpointTkoOperatorList"
                    :earlyCheckedItems="getEarlyCheckedTkoOperator()"
                    :showPaginate="true"
                  )
            div
              municipalities(
                ref="tkoOperator"
                :fields="fields"
                :apo="true"
                @saved="municipalitiesUpdated"
                @delete="municipalitiesUpdated"
              )
          tko-tariff(
            v-if="tabView === 'tariff'"
            ref="tkoTariff"
            :TARIFFS="TARIFFS"
            :tkoOperatorTariffs="fields.tkoOperatorTariffs"
            :hide-calc="true"
            :operatorId="fields.tko_operator_id"
            @updateTariff="updateTariff"
          )
          .body-flex(v-if="tabView === 'calculateTariff'")
            .toolbar.toolbar_no-padding
              .toolbar__line
                div.parameters
                .actions-panel.view-panel
                  e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(
                    @click="addNewRow"
                    label="Добавить"
                  )
            div(slot="label")
            slot
              e-table-editable(
                ref="tariff"
                :attributes="tariffAttr"
                :dataUrl="tariffDataUrl"
                :postUrl="tariffPostUrl"
                :patchUrl="tariffPatchUrl"
                :deleteUrl="tariffDeleteUrl"
                :tableInOnlineMode="tableInOnlineMode"
                @calculateTariff="calculateTariff"
                @afterFetchData="afterFetchData"
                @afterEditRow="afterEditRow"
                :actionColumnWidth="160"
              )
                template(v-slot:year="{model}")
                  e-select(
                    :disabled="model.id > 0"
                    name="year"
                    :model="model"
                    :options="availableYears[model.id || model._storeUUID]"
                  )
            change-log(
              v-if="hasChangeLog"
            )

</template>
<script>
import { Chrome } from 'vue-color'

import { map, tko } from '@/api/api-endpoints'
import formBaseMixin from '@/components/form/form-base-mixin'
import ChangeLog from '@/app/geo/components/change-log'
import hasMixin from '@/mixins/has-mixin'
import textMixin from '@/mixins/text-mixin'
import apoForm from './mixins/apo-form'
import Municipalities from '../registry/components/municipalities'
import TkoTariff from '../registry/components/tko-tariff'
import { REGION_CONFIG } from '@/config/regions'

export default {
  components: { Municipalities, Chrome, ChangeLog, TkoTariff },
  mixins: [apoForm, hasMixin, textMixin],
  data() {
    return {
      tabView: 'tab1',
      fields: {
        name: '',
        color: '',
        mos: [],
        tkoOperatorTariffs: [],
      },
    }
  },
  computed: {
    tabs() {
      const tabs = [{ tab1: 'Общие сведения' }]
      if (this.hasCommonZoneUpdate) {
        tabs.push({ tariff: 'Тарифы' })
      }
      if (this.hasCalculateTariff) {
        tabs.push({ calculateTariff: this.apoTariffTitle })
      }
      return tabs
    },
    tariffDataUrl() {
      return map.apoTariff(this.$route.params.id)
    },
    tableInOnlineMode() {
      return !!this.$route.params.id
    },
    TARIFFS() {
      return REGION_CONFIG.operatorTariffs
    },
    tariffAttr() {
      return {
        value: {
          label: 'Прогнозное значение предельного тарифа (руб.)',
          placeholder: 0.0,
          validationRulePattern: '^[0-9]*[.,]?[0-9]+$',
          invalidMessage: 'Укажите число',
          required: true,
        },
        index: {
          label: 'Предельный индекс, %',
          placeholder: 0,
        },
        inflation: {
          label: 'Коэффициент инфляции',
          placeholder: 0,
        },
        population_growth: {
          label: 'Коэффициент годового прироста населения',
          placeholder: 0,
        },
        sale_of_fractions: {
          label: 'Коэффициент продажи отобранных полезных фракций',
          placeholder: 0,
        },
        tariff_kaf: {
          label: 'Тариф с учетом коэффициентов',
          placeholder: 0,
        },
        index_effect: {
          label: 'Влияние предельного индекса',
          validationRulePattern: '(\\.*)',
          placeholder: '',
        },
        year: {
          label: 'Период регулирования (год)',
          validationRulePattern: '(\\.*)',
          required: true,
          transform: (m) => m.year,
        },
      }
    },
    yesOrNo() {
      return [
        { id: 0, name: 'Нет' },
        { id: 1, name: 'Да' },
      ]
    },
    status() {
      return [
        { id: 'planned', name: 'Планируемый' },
        { id: 'fact', name: 'Фактический' },
      ]
    },
    tkoOperator() {
      return this.$store.getters.readUrlEndpoint(
        tko.operator(this.fields.tko_operator_id)
      )
    },
  },
  methods: {
    getItemOperatorEndpoint(tkoOpId) {
      return tko.operator(tkoOpId)
    },
    onSuccess() {
      if (this.onlyUpdate === true) {
        this.onlyUpdate = false
      } else {
        formBaseMixin.methods.onSuccess.call(this)
      }
    },
    innerUpdated() {
      if (this.fields.id) {
        this.onlyUpdate = true
        this.sendForm()
      }
    },
    addNewRow() {
      const Model = (id) => ({
        year: '',
        value: '',
        index: '',
        inflation: '',
        population_growth: '',
        sale_of_fractions: '',
        tariff_kaf: '',
        index_effect: '',
        calc_kaf: 0,
        apo_id: id || '',
      })
      this.$refs.tariff.createRow(new Model(this.$route.params.id))
    },
    getDeleteUrl(id) {
      return map.apoDelete(id)
    },
    getUpdateOrCreateUrl() {
      return map.apo(this.$route.params.id)
    },
    getItemEndpoint(route) {
      return route.params?.id ? map.apo(route.params.id) : null
    },
    tariffPostUrl() {
      return map.apoTariff(this.$route.params.id)
    },
    tariffPatchUrl(context, model) {
      return map.apoTariffPatch(model.id)
    },
    tariffDeleteUrl(context, model) {
      return map.apoTariffDelete(model.id)
    },
    async afterSave(response) {
      if (this.$route.params.id) {
        return
      }
      const endpoint = map.apoTariff
      let tariffData = this.$store.getters.readUrlEndpoint(endpoint())?.data
      if (!tariffData) {
        return
      }
      let promises = []

      let newTariff = tariffData.filter((item) => !item.apo_id)
      if (response?.data?.id) {
        promises.push(
          this.$store.dispatch('createModel', {
            url: endpoint(response.data.id),
            data: newTariff,
          })
        )
        await Promise.all(promises).then(() => {
          this.$store.commit('setEndpointData', {
            endpoint: endpoint(),
            data: { data: [] },
          })
        })
        return Promise.resolve(1)
      }
    },
    calculateTariff(model) {
      const editButton = document.querySelector(
        `.e-table-editable__fixed-right .e-table-editable__row[data-id="${model.id}"] .row-edit`
      )
      model.calc_kaf = 1
      if (editButton) {
        editButton.click()
        editButton.click()
      }
    },
    prepareFieldsForSend(fields) {
      fields.apoTariffs?.map((item) => {
        item.calc_kaf = 0
      })
      return fields
    },
    afterFetchData(data) {
      this.$nextTick(() => {
        data.response.data.data?.map((item) => {
          this.updateValues(item)
        })
        return data
      })
    },
    afterEditRow(data) {
      data.model.calc_kaf = 0
      this.updateValues(data.model)
    },
    updateValues(data) {
      const values = {
        incomplete_data: 'недостаточно данных для численной проверки',
        exceeded: 'превышает предельный индекс',
        ok: 'вписывается в предельный индекс',
      }
      data.className = data.index_effect
      data.index_effect = values[data.index_effect] || values.incomplete_data
    },
  },
  updateTariff(tariffs) {
    this.tkoOperatorTariffs = tariffs
  },
}
</script>
<style lang="scss" scoped>
.e-button-add.actions-panel__button.btn-add.green {
  margin: 0.5rem;
}
</style>
